import { z } from "zod";
import { DbCreateInputOmit, DbUpdate, nullishToOptional } from "../helpers";
import { OmitStrict } from "../utils";

//
// Enums
//

export const DesignSystemAccessMode = z.enum(["Open", "InviteOnly"]);
export type DesignSystemAccessMode = z.infer<typeof DesignSystemAccessMode>;

//
// Model
//

export const DesignSystemSwitcher = z.object({
  isEnabled: z.boolean(),
  designSystemIds: z.array(z.string()),
});

export const DesignSystem = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  description: z.string(),
  docExporterId: nullishToOptional(z.string()),
  docSlug: z.string(),
  docUserSlug: nullishToOptional(z.string()),
  docSlugDeprecated: z.string(),
  isMultibrand: z.boolean(),
  docViewUrl: nullishToOptional(z.string()),
  basePrefixes: z.array(z.string()),
  designSystemSwitcher: nullishToOptional(DesignSystemSwitcher),
  isApprovalFeatureEnabled: z.boolean(),
  approvalRequiredForPublishing: z.boolean(),
  accessMode: DesignSystemAccessMode,
  membersGenerated: z.boolean(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type DesignSystemSwitcher = z.infer<typeof DesignSystemSwitcher>;
export type DesignSystem = z.infer<typeof DesignSystem>;

export type CreateDesignSystem = DbCreateInputOmit<DesignSystem>;
export type UpdateDesignSystem = OmitStrict<DbUpdate<DesignSystem>, "workspaceId" | "docSlug" | "docSlugDeprecated">;
